// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__jbSoa","range":"MonthRangeSwitch_range__1A5wC","disabled":"MonthRangeSwitch_disabled__2nZaF"};